import { styled, css, Typography, Accordion } from '@mui/material';
import { ArrowForwardIosSharp } from '@mui/icons-material';
import { theme } from 'assets/themes/zizzi';
import { palette } from 'assets/styles/colors';

const alertBgColor = palette.sunshine[500];

interface AlertProps {
  alert: string;
}

export const Wrapper = styled('div')<AlertProps>`
  background: ${theme.palette.primary.main};
  border-radius: ${theme.radius.md};
  padding: 1rem;

  ${({ alert }) =>
    alert === 'true' &&
    css`
      background-color: ${alertBgColor};

      .MuiTypography-root {
        color: ${theme.palette.primary.main};
      }
    `};
`;

export const StyledAccordion = styled(Accordion)`
  &.Mui-disabled,
  .Mui-disabled {
    background: transparent;
    opacity: 1 !important;
  }

  &.MuiAccordion-root {
    background: transparent;
    border: none;
  }

  .MuiAccordionSummary-root {
    align-items: flex-start;
    padding: 0;

    &:hover {
      background: transparent;
    }
  }

  .MuiAccordionSummary-content {
    flex-direction: column;
    margin: 0;
  }

  .MuiAccordionDetails-root {
    padding: 0;
  }
`;

export const Header = styled(Typography)`
  font-weight: bold;
  color: ${theme.palette.white};
`;

export const Arrow = styled(ArrowForwardIosSharp)`
  color: ${theme.palette.white};
  font-size: 1.1rem;
  transform: rotate(90deg);
`;

export const Code = styled(Typography)`
  color: ${theme.palette.white};
`;

export const Text = styled(Typography)`
  color: ${theme.palette.white};
  margin-top: 0.5rem;
`;
